'use strict'

document.addEventListener("DOMContentLoaded", function(event) {
    /********************************
     * Show fixed button
     *******************************/
    const collectionButton = document.querySelector('.button-position');
    const body = document.querySelector('body');

    if(collectionButton){
        const collectionButtonFixed = document.querySelector('.button-position-fixed');
        const add_class_on_scroll = () => collectionButtonFixed.classList.add("show");
        const remove_class_on_scroll = () => collectionButtonFixed.classList.remove("show");
        const screenHeight = window.screen.height;

        setTimeout(()=>{

            const positionButtonTop = collectionButton.getBoundingClientRect().top + window.pageYOffset;
            const positionButton = positionButtonTop + collectionButton.offsetHeight;
            const footerHeight = document.querySelector('footer.footer').offsetHeight;
            const hidePosition = body.offsetHeight - footerHeight;


            window.addEventListener('scroll', function() {
                window.scrollY > positionButton && (window.scrollY + screenHeight) < hidePosition
                    ? add_class_on_scroll()
                    : remove_class_on_scroll();
            });
        }, 1000);
    }

});